// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"CustomModal_modalHeader__wC7N6","modalBody":"CustomModal_modalBody__jIe3_","modalContent":"CustomModal_modalContent__fHBRW"};